import { useMemo, useState } from "react";
import GTextField from "../libs/textfield/GTextField";
import FormGroup from "../libs/form/FormGroup";
import FormControl from "../libs/form/FormControl";
import Validators from "../libs/form/Validators";

export default function(){
    const [value,setValue] = useState<string>("")
    const onChange = (e:any) => setValue(e.target.value)
    const form = useMemo(() => {
        return new FormGroup("group", [
            new FormControl("name", [Validators.Required,Validators.NonZero])
        ])
    },[])
    return <>
        <GTextField form={form} controlName="name" onChange={onChange} value={value}/>
        <div>{form.error}, {form.valid}, {form.dirty}</div>
    </>
}